<template>
  <div class="admin-user-list">
    <div class="toolbar">
      <el-input
        v-model="keyword"
        placeholder="搜索用户名或昵称"
        prefix-icon="el-icon-search"
        clearable
        size="small"
        style="width:240px"
        @clear="loadList"
        @keyup.enter.native="loadList"
      />
      <el-button type="primary" size="small" @click="loadList" style="margin-left:12px">搜索</el-button>
      <el-button type="success" size="small" icon="el-icon-plus" @click="$router.push('/admin-user/create')">新增账号</el-button>
    </div>

    <el-table :data="list" v-loading="loading" stripe style="width:100%">
      <el-table-column type="index" label="#" width="60" />
      <el-table-column prop="username" label="用户名" width="140" />
      <el-table-column prop="nickname" label="昵称" width="140" />
      <el-table-column label="角色" width="100">
        <template slot-scope="{row}">
          <el-tag :type="row.is_super ? 'danger' : 'warning'" size="small">
            {{ row.is_super ? '超级管理员' : '普通管理员' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="website_count" label="可看网站数" width="120" />
      <el-table-column label="状态" width="80">
        <template slot-scope="{row}">
          <el-tag :type="row.status ? 'success' : 'info'" size="small">
            {{ row.status ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="last_login_at" label="最后登录" width="170">
        <template slot-scope="{row}">{{ row.last_login_at || '-' }}</template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="170" />
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" size="small" @click="$router.push('/admin-user/edit/' + row.id)">编辑</el-button>
          <el-button type="text" size="small" @click="showPermission(row)" v-if="!row.is_super">分配权限</el-button>
          <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @current-change="handlePageChange"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
      />
    </div>

    <!-- 权限分配弹窗 -->
    <el-dialog title="分配网站权限" :visible.sync="permDialog" width="600px">
      <p style="margin-bottom:12px;color:#606266">
        用户：<b>{{ permUser.username }}</b>（{{ permUser.nickname }}）
      </p>
      <el-transfer
        v-model="permSelected"
        :data="permAllWebsites"
        :titles="['可选网站', '已选网站']"
        :button-texts="['移除', '添加']"
        filterable
        filter-placeholder="搜索网站"
      />
      <div slot="footer">
        <el-button @click="permDialog = false">取消</el-button>
        <el-button type="primary" @click="savePermissions" :loading="permSaving">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adminUserApi } from '../api';

export default {
  name: 'AdminUserList',
  data() {
    return {
      list: [],
      loading: false,
      keyword: '',
      page: 1,
      pageSize: 20,
      total: 0,
      permDialog: false,
      permUser: {},
      permSelected: [],
      permAllWebsites: [],
      permSaving: false
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    async loadList() {
      this.loading = true;
      try {
        const res = await adminUserApi.list({ page: this.page, page_size: this.pageSize, keyword: this.keyword });
        if (res.code === 0) {
          this.list = res.data.list;
          this.total = res.data.total;
        }
      } catch (e) {
        this.$message.error('加载失败');
      } finally {
        this.loading = false;
      }
    },
    handlePageChange(p) {
      this.page = p;
      this.loadList();
    },
    async showPermission(row) {
      this.permUser = row;
      this.permSelected = [];
      this.permAllWebsites = [];
      try {
        const res = await adminUserApi.getPermissions(row.id);
        if (res.code === 0) {
          this.permAllWebsites = res.data.websites.map(w => ({
            key: w.id,
            label: w.name + ' (' + w.domain + ')'
          }));
          this.permSelected = res.data.website_ids;
          this.permDialog = true;
        }
      } catch (e) {
        this.$message.error('加载权限失败');
      }
    },
    async savePermissions() {
      this.permSaving = true;
      try {
        const res = await adminUserApi.assignPermissions({
          id: this.permUser.id,
          website_ids: this.permSelected
        });
        if (res.code === 0) {
          this.$message.success('权限分配成功');
          this.permDialog = false;
          this.loadList();
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        this.$message.error('保存失败');
      } finally {
        this.permSaving = false;
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除用户「' + row.username + '」？', '删除确认', { type: 'warning' });
        const res = await adminUserApi.delete(row.id);
        if (res.code === 0) {
          this.$message.success('删除成功');
          this.loadList();
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        if (e !== 'cancel') this.$message.error('删除失败');
      }
    }
  }
};
</script>

<style scoped>
.toolbar { display: flex; align-items: center; margin-bottom: 16px; gap: 8px; }
.pagination { margin-top: 16px; text-align: right; }
</style>
